import { useEffect, useRef, useState } from "react";
import { Tooltip, ListItemText } from "@mui/material";

export function HeaderListItem({ text }: { text: string }) {
    const textRef = useRef<HTMLSpanElement | null>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (el) {
            setShowTooltip(el.scrollWidth > el.clientWidth);
        }
    }, [text]);

    return (
        <Tooltip title={text} disableHoverListener={!showTooltip}>
            <ListItemText
                primary={text}
                primaryTypographyProps={{
                    ref: textRef,
                    noWrap: true,
                    sx: {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    },
                }}
            />
        </Tooltip>
    );
}